import moment from 'moment-timezone'

export default {
  recentAccountsThreshold: 0,
  latestUpdate: moment(),
  retests: {},
  retestReasons: []
}
